import * as React from 'react';
import Select from 'react-select';
import { isUSA } from 'src/config';
import { IDocument, IOrderQuantities_Addresses, IState } from '../../infrastructure/interfaces';

export interface IShippingInfoFormProps {
  onFieldChange: any;
  document: IDocument;
  statesList: IState[];
  selectedOrderQuantityAddressPair: IOrderQuantities_Addresses;
}

export interface IShippingInfoFormState {
  document: IDocument;
}

export default class ShippingInfoForm extends React.Component<IShippingInfoFormProps, IShippingInfoFormState> {
  constructor(props: IShippingInfoFormProps) {
    super(props);
    this.state = {
      document: props.document
    }
  }

  render() {
    const stateOptions = this.props.statesList.map(item => ({
      value: item.id,
      label: item.state_abbreviation
    }));
    const selectedState = this.props.statesList.filter(state => state.state_abbreviation == this.props.selectedOrderQuantityAddressPair.address.shipState)[0];

    const inputClassName = 'companyInfoInput settingCompanyInfoInput';

    const optionTo1000 = Array.from({length:41},(v,k)=>k*25)
    return (
      <div className="shippingInfoContainer">
        <div className="shippingInfoInputContainer">
          <label>
            Ship Name *
          </label>
          <div>
            <input
              className={`${inputClassName}`}
              type="text"
              name="shipName"
              value={this.props.selectedOrderQuantityAddressPair.address.shipName}
              onChange={this.props.onFieldChange}
            />
          </div>
        </div>
        <div className="shippingInfoInputContainer">
          <label>
            Ship Address 1 *
          </label>
          <div>
            <input
              className={`${inputClassName}`}
              type="text"
              name="shipAddress1"
              value={this.props.selectedOrderQuantityAddressPair.address.shipAddress1}
              onChange={this.props.onFieldChange}
            />
            <span>No P.O. Boxes. Must use physical address.</span>
          </div>
        </div>
        <div className="shippingInfoInputContainer">
          <label>
            Ship Address 2
          </label>
          <div>
            <input
              className={`${inputClassName}`}
              type="text"
              name="shipAddress2"
              value={this.props.selectedOrderQuantityAddressPair.address.shipAddress2}
              onChange={this.props.onFieldChange}
            />
          </div>
        </div>
        <div className="shippingInfoInputContainer">
          <label>
            Ship City *
          </label>
          <div>
            <input
              className={`${inputClassName}`}
              type="text"
              name="shipCity"
              value={this.props.selectedOrderQuantityAddressPair.address.shipCity}
              onChange={this.props.onFieldChange}
            />
          </div>
        </div>
        <div className="shippingInfoInputContainer">
          <label>
            Ship State *
            </label>
          <div>
            <Select
              className={`select-state`}
              name="shipState"
              options={stateOptions}
              value={{ label: (this.props.selectedOrderQuantityAddressPair.address.shipState != undefined) ? this.props.selectedOrderQuantityAddressPair.address.shipState : '', value: (selectedState != undefined) ? selectedState.id : -1 }}
              onChange={(e) => {

                var labelValue = '';
                if ((e != undefined) && (e != null)){
                  labelValue = e["label"];
                }
                this.props.onFieldChange({ target: { name: 'shipState', value: labelValue } });
              }}
            />
          </div>
        </div>
        <div className="shippingInfoInputContainer">
          <label>
            Ship Postal Code *
          </label>
          <div>
            <input
              className={`${inputClassName}`}
              type="text"
              name="shipPostalCode"
              maxLength={isUSA() ? 5 : 7}
              value={this.props.selectedOrderQuantityAddressPair.address.shipPostalCode}
              onChange={this.props.onFieldChange}
            />
          </div>
        </div>
        <div className="shippingInfoInputContainer">
          <label>
            Ship Country *
          </label>
          <div>
            <input
              className={`${inputClassName}`}
              type="text"
              name="shipCountry"
              value={this.props.selectedOrderQuantityAddressPair.address.shipCountry}
              disabled={true}
            />
          </div>
        </div>
        <div className="shippingInfoInputContainer">
          <label>
            Quantity Ordered *
          </label>
          <div>
            {this.props.document.type === 'Poster' ?
            <select className={`${inputClassName}`}
              value={this.props.selectedOrderQuantityAddressPair.orderQuantity}
              name="orderQuantity"
              onChange={this.props.onFieldChange}
            >
              <option></option>
              <option>5</option>
              <option>10</option>
              <option>15</option>
              <option>20</option>
              <option>25</option>
              <option>30</option>
              <option>35</option>
              <option>40</option>
              <option>45</option>
              <option>50</option>
            </select>
            : 
            <select className={`${inputClassName}`}
              value={this.props.selectedOrderQuantityAddressPair.orderQuantity}
              name="orderQuantity"
              onChange={this.props.onFieldChange}
            > 
            {optionTo1000.map(index => <option>{index}</option>)}

          </select>}
          </div>
        </div>
        <div className="shippingInfoInputContainer">
          <label>
            Division ID *
          </label>
          <div>
            <input
              className={`${inputClassName}`}
              type="text"
              name="divisionId"
              value={this.props.selectedOrderQuantityAddressPair.address.divisionId}
              onChange={this.props.onFieldChange}
            />
          </div>
        </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/ShippingInfoForm.tsx